export default "__VITE_ASSET__C_3ooWhI__"